import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import { AcademicSessionGuard } from '@/components/common/AcademicSessionGuard';

export function StudentsLayout() {
  return (
    <AcademicSessionGuard>
      <Box sx={{ width: '100%' }}>
        <Outlet />
      </Box>
    </AcademicSessionGuard>
  );
}
